import s from './Close.module.css'

type Props = {
  onClick: () => void
  size?: 'sm' | 'md'
  disabled?: boolean
}

export const Close = ({ onClick, size = 'md', disabled = false }: Props) => {
  return (
    <button
      className={`${s.close} ${s[size]}`}
      type="button"
      onClick={onClick}
      disabled={disabled}
    >
      ×
    </button>
  )
}
